import React from 'react';
import PropTypes from 'prop-types';
import { icons } from 'smartsuite-ui/lib/constants/icons';

export default function EditorDrawerRail(props) {
    return (
        <button
            type="button"
            className="editor-drawer-rail"
            onClick={props.toggleDrawer}
        >
            <span
                className={`${icons.chevronRight} editor-drawer-rail__icon`}
            />
        </button>
    );
}
EditorDrawerRail.propTypes = {
    toggleDrawer: PropTypes.func.isRequired,
};
